import React from "react";

const StyledHeading = ({ children, fontColor }) => {
  return (
    <p className={`text-h4 font-inter ${fontColor}`}>{children}</p>
  );
};

export default StyledHeading;
